export const TIME_LOGOUT= 3000;
export const SIZE_PAGINATION= 30;
export const PATH= '';
export const TOKEN_STRING= 'Bearer ';

// COOKIES
export const ID_TOKEN = 'idTokenWebRicaurteSystem';

export const LOGO_URL = 'https://firebasestorage.googleapis.com/v0/b/gadricaurte-2bdf0.appspot.com/o/logo.jpeg?alt=media&token=14e7f14a-a57a-4f9e-8f55-cb46285b9cc5'
